import { useLocation } from 'react-router';
import React, { useEffect } from 'react';
import { generalStore } from '../../store';

const NavigationManager = () => {
    const location = useLocation();
    const setIsSearchBarOpen = generalStore(state => state.setIsSearchBarOpen);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setIsSearchBarOpen(false);
        }, 100);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [location.pathname, location.search, setIsSearchBarOpen]);

    return <div />;
};

export default NavigationManager;
